import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  Button,
  //Card,
  //Col,
  Dropdown,
  Form,
  Layout,
  Input,
  //Modal,
  Menu,
  Row,
  //Space,
  Tooltip,
  //Typography,
} from 'antd';
import {
  CheckOutlined,
  EllipsisOutlined,
  InfoCircleOutlined,
  //PlusOutlined,
  SaveOutlined,
  SearchOutlined,
} from '@ant-design/icons';
//import SearchSelect2 from 'components/Inventory/MoveMerge/SearchSelect2';
//import { FormItemLeft, LockerBox } from 'components/Inventory/MoveMerge/style';
import {
  CardSection,
  //ExportCSV,
  FormLabel,
  HeaderTitle,
  //InfoButton,
  //InputInteger as InputNumber,
  Label,
  //Locker,
  Loading,
  ScreenMask,
  //SelectProduct,
  //SelectWarehouse,
  SecondaryButton,
  message,
} from 'components/common';
import {
  COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
  COMMON_MSG_DEFAULT_DISPLAY_DURATION,
  HTTP_STATUS_OK,
  LOADING_ICON_SIZE1,
} from 'constants/config';
import {
  editWarehousePostedTransfer,
  fetchWarehousePostedTransferDetail,
  fetchWarehousePostedTransferDetailByBatchNumber,
} from 'services/inventory';
import { convertTimeByUtc } from 'utils';
import { editTransferBatch, isErrorExist, submitTransferBatch } from '../WarehouseTransferErpList';
import TransferLineGrid, { TransferLineGridMode } from '../WarehouseTransferErpList/TransferLineGrid';
//import { isErrorExist } from '../WarehouseTransferWmsList';

const WarehouseTransferErpProcess = () => {
  const { useState } = React;
  //const { Text } = Typography
  // eslint-disable-next-line
  const [DLocationLock6, setDLocationLock6] = useState(false);
  // eslint-disable-next-line
  const [SLocationLock6, setSLocationLock6] = useState(false);
  const [batch, setBatch] = useState<StringKAnyVPair>({});
  const [batchNote, setBatchNote] = useState('');
  const [batchNumber, setBatchNumber] = useState('');
  // eslint-disable-next-line
  const [destWHLocked, setDestWHLocked] = useState(true);
  const [gridVersion, setGridVersion] = useState(0);
  // eslint-disable-next-line
  const [identifierLocked, setIdentifierLocked] = useState(false);
  // eslint-disable-next-line
  const [lineNotedLocked, setLineNoteLocked] = useState(false);
  const [lockScreen, setLockScreen] = useState(false);
  // eslint-disable-next-line
  const [lotEnable, setLotEnable] = useState(false);
  const [lotUomInfo, setLotUomInfo] = useState<{ uom : string, uomRate : number, lotNumber : string }>();
  // eslint-disable-next-line
  const [qtyRef, setQtyRef] = useState(0);
  // eslint-disable-next-line
  const [quantityLock6, setQuantityLock6] = useState(false);
  const [referenceNumber, setReferenceNumber] = useState('');
  const [searchBNVersion, setSearchBNVersion] = useState(0);
  const [searchBatchNumber, setSearchBatchNumber] = useState('');
  // eslint-disable-next-line
  const [selectLotUomDialogVisible, setSelectLotUomDialogVisible] = useState(false);
  // eslint-disable-next-line
  const [selectedProduct6, setSelectedProduct6] = useState<ProductRow>();
  // eslint-disable-next-line
  const [selectedSWarehouse6, setSelectedSWarehouse6] = useState<StringKAnyVPair>();
  // eslint-disable-next-line
  const [selectedWarehouse6, setSelectedWarehouse6] = useState<StringKAnyVPair>();
  // eslint-disable-next-line
  const [sourceWHLocked, setSourceWHLocked] = useState(true);
  const [transferNumber, setTransferNumber] = useState(0);
  // eslint-disable-next-line
  const [uomEnable, setUomEnable] = useState(false);

  const [recvForm] = Form.useForm();
  const history = useHistory();

  /*const formItemLayout = {
    labelCol: {
      sm: { span: 8 },
    },
    wrapperCol: {
      sm: { span: 16 },
    },
  };*/

  const checkBatchNumberFromHash = () => {
    //const { location } = window;
    //const paramsId = (location.hash.charAt(0) === '#' ? location.hash.slice(1).split('&') : []).map(e => e.split('=')).filter(e => e[0] === 'id');
    const queryParams = new URLSearchParams(window.location.search);
    const id = Number(queryParams.get('id') || '0');

    //if (paramsId.length > 0) {
    if (!isNaN(id)) {
      //const id = Number(paramsId[0][1]);
      //setTransferNumber(isNaN(id) ? 0 : id);
      if (id > 0 && id !== transferNumber) {
        console.log('uh clear and load', id);
        clearTransferBatch();
        setTransferNumber(id);

        if (id > 0) {
          loadDetail(id);
        }
      }
    }
  };

  const clearTransferBatch = () => {
    setBatch({});
    setBatchNote('');
    setBatchNumber('');
    setReferenceNumber('');
    setTransferNumber(0);
  };

  const handleSearchBatchNumber = async (bn = searchBatchNumber) => {
    //console.log('s bn', bn);
    if (bn === batchNumber) {
      setSearchBNVersion(searchBNVersion + 1);
      return;
    }

    setLockScreen(true);
    try {
      const detail = await fetchWarehousePostedTransferDetailByBatchNumber(bn);

      if (detail) {
        //console.log('d', detail);
        clearTransferBatch();
        editTransferBatch(history);
        setBatch(detail);
        setBatchNote(detail.note);
        setBatchNumber(detail.batchNumber);
        setReferenceNumber(detail.referenceNumber);
        setTransferNumber(detail.postedTransferNum);
        setSearchBNVersion(searchBNVersion + 1);
      }
    } catch(e) {
    } finally {
      setLockScreen(false);
    }
  };

  const isTransferChanged = () => {
    return batch.note !== batchNote.trim() || batch.referenceNumber !== referenceNumber.trim();
  };

  const isTransferEditable = () => {
    return isTransferExisted() && batch.status === 0;
  };

  const isTransferExisted = () => {
    //return transferNumber > 0;
    return batch.postedTransferNum > 0;
  };

  /*const isTransferLineAddable = () => {
    let ret = true;

    if (isTransferExisted()) {
      ret = isTransferEditable();
    }

    return ret;
  };*/

  const lineGridMode = () => {
    return isTransferEditable() ? TransferLineGridMode.Edit : TransferLineGridMode.View;
  };

  const loadDetail = async (tn: number) => {
    setLockScreen(true);
    try {
      const detail = await fetchWarehousePostedTransferDetail(tn);

      if (detail) {
        //console.log('d', detail);
        setBatch(detail);
        setBatchNote(detail.note);
        setBatchNumber(detail.batchNumber);
        setReferenceNumber(detail.referenceNumber);
        setTransferNumber(tn);
      }
    } catch(e) {
    } finally {
      setLockScreen(false);
    }
  };

  const onChangeBatchNote = (evt: any) => {
    setBatchNote(evt.target.value);
  };

  const onChangeSearchBatchNumber = (evt: any) => {
    const bn = evt.target.value.trim();

    setSearchBatchNumber(bn);
  };

  const onLoadTransferBatch = (tb: StringKAnyVPair) => {
    setBatch(tb);
  };

  // eslint-disable-next-line
  const onProductChange = (product: any) => {
    //console.log('ch', product);
    setSelectedProduct6(product);
    recvForm.setFieldsValue({ Identifer6: product.sku });

    if (selectedProduct6 && product.id !== selectedProduct6.id) {
      setLotUomInfo(undefined);
    }

    openProductLotUomDialog(product);
  };

  const onReferenceNumberChange = (evt: any) => {
    setReferenceNumber(evt.target.value);
  };

  const onSearchBatchNumberKeyDown = (evt: any) => {
    if ([9, 13].indexOf(evt.keyCode) > -1) {
      const key = evt.target.value.trim();

      key && handleSearchBatchNumber(key);
    }
  };

  const openProductLotUomDialog = (product: any) => {
    if (product && typeof product === 'object' && product.id > 0) {
      if (lotEnable || uomEnable) {
        setSelectLotUomDialogVisible(true);
      }
    } else {}
  };

  const renderLineGrid = () => {
    return (<>
      <div
        className="mt-8 n-c-d-h-100"
        style={{height: 'calc(100vh - 198px)', maxHeight: 900}}
      >
        {/*transferNumber > 0 && batchNumber && (*/}
        {isTransferExisted() && (
          <TransferLineGrid
            mode={lineGridMode()}
            onLoadTransfer={onLoadTransferBatch}
            transferNumber={batch.postedTransferNum}
            version={gridVersion}
          />
        )}
      </div>
    </>);
  };

  const renderSearchForm = () => {
    return (
      <Row>
        <Input
          addonAfter={(
            <Button
              className="b-none h-30 p-5-8"
              disabled={!searchBatchNumber.trim()}
              onClick={() => handleSearchBatchNumber()}
              type="primary"
            >
              <SearchOutlined />
            </Button>
          )}
          allowClear
          className="input-addon-btn"
          key={`search-bn${searchBNVersion}`}
          onChange={onChangeSearchBatchNumber}
          onKeyDown={onSearchBatchNumberKeyDown}
          placeholder="Batch Number"
          style={{ width: 360 }}
        />
      </Row>
    );
  };

  const renderSider = () => {
    return (
      <div className="ant-card-bordered br-10 ml-8 p-8">
        <Row align="middle" className="bb-solid-f0 pb-8" justify="space-between">
          {isErrorExist(batch) ? (
            <Tooltip
              placement="top"
              //title={typeof row.error === 'string' ? row.error.replace(/\n/g, '<br />') : row.error}
              title={batch.error}
              trigger={['hover', 'click']}
            >
              <InfoCircleOutlined className="text-error1 fs-22" />
            </Tooltip>
          ) : (
            <span>&nbsp;</span>
          )}
          <Dropdown
            overlay={(
              <Menu>
                <Menu.Item disabled={!isTransferEditable()} onClick={() => submitBatch()}  key="submit-batch-dd-menu">
                  <Label className={isTransferEditable() ? 'label-primary clickable' : 'label-disabled'}>
                    <CheckOutlined />
                    &nbsp;Submit
                  </Label>
                </Menu.Item>
              </Menu>
            )}
          >
            <Button className="h-28 p-3-6">
              <EllipsisOutlined />
            </Button>
          </Dropdown>
        </Row>
        <Row align="middle" className="bb-dashed pb-4 pt-4">
          <FormLabel>Batch Number</FormLabel>
          {isTransferExisted() && <Label className="label-grey ml-4">{batchNumber}</Label>}
        </Row>
        {isTransferExisted() && (
          <Row align="middle" className="bb-dashed pb-4 pt-4">
            <FormLabel>ERP Order Number</FormLabel>
            <Label className="label-grey ml-4">{batch.saleOrderNumber}</Label>
          </Row>
        )}
        {isTransferExisted() && (
          <Row align="middle" className="bb-dashed pb-4 pt-4">
            <FormLabel>Channel Order Id</FormLabel>
            <Label className="label-grey ml-4">{batch.channelOrderId}</Label>
          </Row>
        )}
        {isTransferExisted() && (
          <Row align="middle" className="bb-dashed pb-4 pt-4">
            <FormLabel>From Warehouse</FormLabel>
            <Label className="label-grey ml-4">{batch.fromWarehouseCode}</Label>
          </Row>
        )}
        {isTransferExisted() && (
          <Row align="middle" className="bb-dashed pb-4 pt-4">
            <FormLabel>To Warehouse</FormLabel>
            <Label className="label-grey ml-4">{batch.toWarehouseCode}</Label>
          </Row>
        )}
        {isTransferExisted() && (
          <Row align="middle" className="bb-dashed pb-4 pt-4">
            <FormLabel>Create Date</FormLabel>
            <Label className="label-grey ml-4">{convertTimeByUtc(batch.createDate)}</Label>
          </Row>
        )}
        {isTransferExisted() && (
          <Row align="middle" className="bb-dashed pb-4 pt-4">
            <FormLabel>Update Date</FormLabel>
            <Label className="label-grey ml-4">{convertTimeByUtc(batch.updateDate)}</Label>
          </Row>
        )}
        <Row className="pt-4">
          <FormLabel>Reference Number</FormLabel>
          <Input
            allowClear
            disabled={!isTransferEditable()}
            onChange={onReferenceNumberChange}
            value={referenceNumber}
          />
        </Row>
        <div className="pt-4">
          <FormLabel>Group Note</FormLabel>
          <Input.TextArea
            allowClear
            disabled={!isTransferEditable()}
            onChange={onChangeBatchNote}
            rows={3}
            value={batchNote}
          >
          </Input.TextArea>
          <Row className="mt-8" justify="end">
            <SecondaryButton
              disabled={!(isTransferEditable() && isTransferChanged())}
              onClick={saveBatch}
            >
              <SaveOutlined />
              Save
            </SecondaryButton>
          </Row>
        </div>
      </div>
    );
  };

  const saveBatch = async () => {
    setLockScreen(true);
    try {
      const rn = referenceNumber.trim();
      const bn = batchNote.trim();
      const bd = {
        ReferenceNumber: rn,
        Note: bn,
      };
      const res = await editWarehousePostedTransfer(batch.postedTransferNum, bd);

      if (res) {
        setBatch({
          ...batch,
          note: bn,
          referenceNumber: rn,
        });
        setBatchNote(bn);
        setReferenceNumber(rn);
        message.success({
          content: `Saved successfully`,
          duration: COMMON_MSG_DEFAULT_DISPLAY_DURATION,
        });
      }
    } catch(e) {
      message.error({
        content: `Saved error: ${e}`,
        duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
      });
    } finally {
      setLockScreen(false);
    }
  };

  // eslint-disable-next-line
  const saveLine = async () => {
    const formParam = await recvForm.validateFields();
    const param = {
      FromWarehouseNum: formParam.SWarehouse6.warehouseNum,
      FromLocationNum: formParam.SLocation6,
      ToWarehouseNum: formParam.DWarehouse6.warehouseNum,
      ToLocationNum: formParam.DLocation6,
      // @ts-ignore
      FulfillmentProductNum: selectedProduct6.fulfillmentProductNum,
      // @ts-ignore
      SKU: selectedProduct6.sku,
      LotNumber: '',
      Uom: 'EA',
      UomRate: 1,
      Quantity: Number(formParam.Quantity6) || 0,
      Note: formParam.LineNote,
    };
    //let tn = transferNumber;
    let tn = batch.postedTransferNum || 0;

    if ((lotEnable || uomEnable) && !lotUomInfo) {
      openProductLotUomDialog(selectedProduct6);
      return;
    }
    // console.log('fp', formParam);tryClearLineForm(formParam);return;

    if (lotUomInfo) {
      // @ts-ignore
      param.LotNumber = lotUomInfo.lotNumber || '';
      // @ts-ignore
      param.Uom = lotUomInfo.uom || 'EA';
      // @ts-ignore
      param.UomRate = lotUomInfo.uomRate || 1;
    }

    setLockScreen(true);

    if (tn === 0) {
      try {
        //const res = await addWarehouseBatchTransfer();
        const res: StringKAnyVPair = {};
        let added = false;

        if (res && typeof res === 'object') {
          console.log('res', res);
          if (res.code === HTTP_STATUS_OK && res.isSuccess) {
            tn = res.data.postedTransferNum;
            added = true;
          }
        }

        if (!added) {
          message.error({
            content: `Adding transfer item failed`,
            duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
          });
          setLockScreen(false);
          return;
        }
      } catch(e) {
        message.error({
          content: `Added transfer item error: ${e}`,
          duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
        });
        setLockScreen(false);
        return;
      }
    }

    //console.log('f', formParam, lotUomInfo, param);
    try {
      //const res = await addWarehouseBatchTransferLine(tn, param);
      const res: StringKAnyVPair = {};

      console.log('res', res);
      if (res && typeof res === 'object') {
        if (res.code === HTTP_STATUS_OK && res.isSuccess) {
          message.success({
            content: 'Added successfully',
            duration: COMMON_MSG_DEFAULT_DISPLAY_DURATION,
          });

          tryClearLineForm(formParam);
          //if (transferNumber === 0) {
          if (batch.postedTransferNum === undefined) {
            //editTransferBatch(history, tn);
          } else {
            setGridVersion(gridVersion + 1);
          }
        }
      }
    } catch(e) {
      /*// @ts-ignore
      let msg = (e && typeof e === 'object' && e.response && e.response.data && typeof e.response.data === 'string') ? e.response.data : `${e}`;

      message.error({
        content: `Added line error: ${msg}`,
        duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
      });*/
    } finally {
      setLockScreen(false);
    }
  };

  const submitBatch = () => {
    submitTransferBatch(
      batch,
      setLockScreen,
      (tb: StringKAnyVPair) => {
        batch.status = tb.status;
        batch.updateBy = tb.updateBy;
        batch.updateDate = tb.updateDate;
        setBatch({ ...batch });
        message.success({
          content: 'Submitted successfully',
          duration: COMMON_MSG_DEFAULT_DISPLAY_DURATION,
        });
      },
    );
  };

  const tryClearLineForm = (fvObj: StringKAnyVPair) => {
    if (!SLocationLock6) fvObj.SLocation6 = undefined;
    if (!quantityLock6) fvObj.Quantity6 = undefined;
    if (!DLocationLock6) fvObj.DLocation6 = undefined;
    if (!lineNotedLocked) fvObj.LineNote = undefined;
    if (!sourceWHLocked) {
      fvObj.SWarehouse6 = undefined;
      setSelectedSWarehouse6(undefined);
    }
    if (!destWHLocked) {
      fvObj.DWarehouse6 = undefined;
      setSelectedWarehouse6(undefined);
    }
    if (!identifierLocked) {
      fvObj.Identifer6 = '';
      setSelectedProduct6(undefined);
      setLotUomInfo(undefined);
    }

    console.log('vo', fvObj);
    recvForm.setFieldsValue(fvObj);
  };

  React.useEffect(() => {
    checkBatchNumberFromHash();
  });

  return (<>
    <HeaderTitle breadcrumb={['Warehouse Transfer', 'Erp Posted Transfer', 'Process']} />
    <CardSection>
      <Layout className="bg-no">
        <Layout.Content>
          {renderSearchForm()}
          {renderLineGrid()}
        </Layout.Content>
        <Layout.Sider className="bg-no" width={210}>
          {renderSider()}
        </Layout.Sider>
      </Layout>
    </CardSection>
    {lockScreen && (
      <ScreenMask>
        <Loading size={LOADING_ICON_SIZE1} />
      </ScreenMask>
    )}
  </>);
};

export default WarehouseTransferErpProcess;

export enum EPTLineActionType {
  Edit = 1,
  Split,
};

export enum SourceType {
  From,
  To,
};
